export const randomNum = () => {
  return Math.floor(Math.random() * (235 - 52 + 1) + 52);
};

export const randomRGB = () => {
  return `rgb(${randomNum()}, ${randomNum()}, ${randomNum()})`;
};

export function downloadFile(url: string, fileName: string) {
  var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onload = function () {
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(this.response);
    var tag = document.createElement('a');
    tag.href = imageUrl;
    tag.download = fileName;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  xhr.send();
}

export function sortByOrder<T extends { order?: number }>(array: T[]) {
  return array.sort((a, b) => {
    // If both have order, sort by order
    if (a.order !== undefined && b.order !== undefined) {
      return a.order - b.order;
    }
    // If only a has order, a comes first
    if (a.order !== undefined) {
      return -1;
    }
    // If only b has order, b comes first
    if (b.order !== undefined) {
      return 1;
    }
    // If neither has order, maintain original order
    return 0;
  });
}
